<template>
	<report-page
		:start-date="true"
		get-url="/bo/report/finance/unpaidinvoices"
		title="Unpaid Invoice Report"
		export-filename="unpaid_invoices"
	/>
</template>

<script>
export default {
	name: 'UnpaidInvoicesReport'
};
</script>
